import React from 'react';
import MockupPreviewPage from '../Mockups/MockupPreviewPage';

/** Generation type 3: coloring pages. */
const MockupsColoringPage = () => (
    <MockupPreviewPage title="Coloring preview" subtitle="Coloring-page mockups generated from customer photos." generationTypeId={3} />
);

export default MockupsColoringPage;
